import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { getAll as getChosenPackages } from "@Api/Customers/chosenPackages";
import LoadingFallback from "@Components/Pages/Fallbacks/Loading";
import GetPath from "@Helpers/GetPath";
import { INSTANT_DEAL_DETAIL } from "@Shared/Paths/Customer";
import DealsTable from "./DealsTable";
import styles from "./index.module.scss";
import { mapChosenPackagesToChosenDeals } from "./mapChosenDeals";
import { PAGE_SIZE } from "./types";
const PredictInstantDashboard = ({ customerId }) => {
    const history = useHistory();
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    useEffect(() => {
        let cancelled = false;
        const loadDeals = async () => {
            setLoading(true);
            try {
                const chosenPackages = await getChosenPackages(customerId);
                if (!cancelled) {
                    const mapped = mapChosenPackagesToChosenDeals(chosenPackages);
                    const sorted = [...mapped].sort((a, b) => b.date.getTime() - a.date.getTime());
                    setDeals(sorted);
                }
            }
            catch (error) {
                console.error("Failed to load customer predict instant deals", error);
                if (!cancelled) {
                    setDeals([]);
                }
            }
            finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        loadDeals();
        return () => {
            cancelled = true;
        };
    }, [customerId]);
    const totalPages = Math.max(1, Math.ceil(deals.length / PAGE_SIZE));
    const currentPage = Math.min(page, totalPages);
    const pageDeals = useMemo(() => {
        const start = (currentPage - 1) * PAGE_SIZE;
        return deals.slice(start, start + PAGE_SIZE);
    }, [deals, currentPage]);
    if (loading) {
        return React.createElement(LoadingFallback, null);
    }
    return (React.createElement("div", { className: styles.page },
        React.createElement("div", { className: styles.body },
            React.createElement("div", { className: styles.pageHeader },
                React.createElement("div", { className: styles.pageHeaderText },
                    React.createElement("h1", { className: styles.title },
                        "Thank you for using",
                        " ",
                        React.createElement("span", { className: styles.titleAccent }, "Predict Instant")),
                    React.createElement("p", { className: styles.subtitle }, "Review your selected Predict Instant deals or create a new one."))),
            React.createElement(DealsTable, { deals: pageDeals, currentPage: currentPage, totalPages: totalPages, onViewDeal: (dealId) => {
                    const deal = pageDeals.find((item) => item.id === dealId);
                    history.push({
                        pathname: GetPath(INSTANT_DEAL_DETAIL, dealId),
                        state: { supplierName: deal?.supplierName },
                    });
                }, onPreviousPage: () => setPage((current) => Math.max(1, current - 1)), onNextPage: () => setPage((current) => Math.min(totalPages, current + 1)) }))));
};
export default connect(({ auth: { user } }) => ({
    customerId: user.customerId,
}))(PredictInstantDashboard);
